import stopLayer from '../helper/stopLayer';
import MMapAbstract from './MMapAbstract';

class MMap extends MMapAbstract {
  constructor(
    parentElement,
  ) {
    super(parentElement);

    const buttonCloseMapElement = parentElement.querySelector('button[data-action="close-map"]');

    // event listener
    parentElement.addEventListener('click', () => {
      if (!window.matchMedia('(min-width: 920px)').matches) {
        if (!parentElement.classList.contains('-extend')) {
          parentElement.classList.add('-extend');
          this.map.resize();
          if (this.userInteracted === false) {
            window.oTripRequest?.mTrips?.[0]?.showRoute();
          }
        }
      }
    });
    buttonCloseMapElement.addEventListener('click', (event) => {
      event.stopPropagation();
      parentElement.classList.remove('-extend');
      this.map.resize();
    });

    // init
    parentElement.appendChild(this.element);

    // event listener
    this.map.on('load', () => {
      this.addAllStops();
      window.oTripRequest?.mTrips?.[0]?.setCurrent();
    });
  }

  onResize() {
    super.onResize();
    if (window.matchMedia('(min-width: 920px)').matches) {
      this.boundsPadding = {
        top: 40,
        bottom: 40 + 70,
        left: 40,
        right: 40,
      };
    }
  }

  onPopupButtonClick(event) {
    const { target } = event;
    const mPopupContentElement = target.closest('.m-popup-content');
    const { oTripRequest } = window;
    if (mPopupContentElement && oTripRequest) {
      const { dataset } = mPopupContentElement;
      let location;
      if (dataset.stopId) {
        location = {
          type: 'stop',
          id: dataset.stopId,
          name: dataset.name,
        };
      } else if (dataset.geoPosition) {
        const geoPosition = dataset.geoPosition.split(',');
        location = {
          type: 'poiGeoPosition',
          geoPosition: {
            longitude: geoPosition[0],
            latitude: geoPosition[1],
          },
          name: dataset.name,
        };
      }
      if (target.dataset.action === 'set-from') {
        oTripRequest.setFrom(location);
      }
      if (target.dataset.action === 'set-to') {
        oTripRequest.setTo(location);
      }
    }
  }

  async addAllStops() {
    const stops = await fetch('/api/stops').then((response) => response.json());
    if (stops.data) {
      let { data } = stops;
      data = data.map((stop) => {
        const { name, id, geoPosition } = stop;
        return {
          type: 'Feature',
          properties: {
            name,
            id,
            sizerank: 13,
          },
          geometry: {
            type: 'Point',
            coordinates: [
              parseFloat(geoPosition.longitude),
              parseFloat(geoPosition.latitude),
            ],
          },
        };
      });
      const geojson = {
        type: 'geojson',
        data: {
          type: 'FeatureCollection',
          features: data,
        },
      };
      this.map.addSource('stops', geojson);

      stopLayer.source = 'stops';

      this.map.addLayer(stopLayer, 'settlement-major-label');
    }
  }
}

export default MMap;
